import { useQuery } from '@tanstack/react-query'
import useApi from './useApi'
import useAuth from './useAuth'

const useUserPermissions = () => {
    const { getMe } = useApi()
    const { Auth } = useAuth()

    const { data, isLoading } = useQuery({
        queryKey: ['me-permissions', Auth.id, Auth.orgId],
        queryFn: () => getMe('me/permissions'),
        enabled: !!(Auth.id && Auth.orgId),
        staleTime: 5 * 60 * 1000,  // 5 min — matches server-side cache TTL
    })

    return {
        isOwner:   data?.isOwner   ?? false,
        isPending: data?.isPending ?? false,
        apps:      data?.apps      ?? [],
        isLoading,
    }
}

export default useUserPermissions
